import React, { useState } from "react";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import PropTypes from "prop-types";
import PasswordIcon from "./PasswordIcon";
import { useStyles } from "../../style/components/formStyle";
import { useTranslation } from "react-i18next";

ValidatorForm.addValidationRule("isPasswordStrong", (value) => {
  const hasLowercase = /[a-z]/.test(value);
  const hasUppercase = /[A-Z]/.test(value);
  return value.length >= 8 && hasLowercase && hasUppercase;
});

const PasswordInput = ({
  onChange,
  value,
  label,
  customValidatorNames = [],
  ...other
}) => {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);
  const classes = useStyles();

  return (
    <TextValidator
      className={classes.password}
      label={label ? label : ""}
      margin="normal"
      value={value}
      variant="outlined"
      validators={[
        "minStringLength:8",
        "required",
        "isPasswordStrong",
        ...customValidatorNames,
      ]}
      errorMessages={[
        t("MinPassLength"),
        t("FieldRequired"),
        t("passCriteria"),
        t("PasswordMismatch"),
      ]}
      fullWidth
      name="password"
      type={showPassword ? "text" : "password"}
      onChange={(event) => onChange(event.target.value)}
      InputProps={{
        endAdornment: (
          <PasswordIcon
            showPassword={showPassword}
            setShowPassword={setShowPassword}
          />
        ),
      }}
      {...other}
    />
  );
};

PasswordInput.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};

export default PasswordInput;
